import React, { memo } from 'react';
import PropTypes from 'prop-types';

const NameAndAddress = ( { row } ) => {
	return (
		<div style={{
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			textOverflow: 'ellipsis'
		}}>
			<span>{ row.name ? `${ row.name }` : `${ row.lastName }, ${ row.firstName }` }</span>
			<br/>
			<address style={{
				whiteSpace: 'nowrap',
				overflow: 'hidden',
				textOverflow: 'ellipsis'
			}}>
				{ row.address
					? <>
						<span>
							{ row.address }
							&nbsp;
							{ row.address2
								? <span className="no-break">{ row.address2 }</span>
								: null
							}
						</span>
						<br/>
						<span>{ `${ row.city }, ${ row.state } ${ row.zip }` }</span>
					</>
					: null
				}
			</address>
		</div>
	);
};

NameAndAddress.propTypes = { row: PropTypes.object.isRequired };

export default memo( NameAndAddress );
